import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { ChevronRight, ErrorOutline } from '@material-ui/icons';

const S = {
  Content: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  ErrorOutline: styled(ErrorOutline)`
  margin-bottom: 1.5rem;
  color: ${({ theme }) => theme.palette.grey[300]};
  font-size: 7.5rem;
`,
  Paragraph: styled.p`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: ${({ marginBottom }) => marginBottom};
    color: ${({ theme }) => theme.palette.grey[900]};
    font-size: 1rem;
    line-height: 1.5;
    text-align: center;
  `,
  Crumbs: styled.div`
    display: flex;
    align-items: align-center;
    margin-bottom: 4rem;
    color: ${({ theme }) => theme.palette.secondary.main};
  `,
  Crumb: styled.span`
    color: ${({ theme }) => theme.palette.secondary.main};
    font-weight: 700;
    text-align: center;
    line-height: 1.5;
    :not(:last-child) {
      margin-right: 0.125rem;
    }
  `,
  ChevronRight: styled(ChevronRight)`
  color: ${({ theme }) => theme.palette.grey[400]};
  font-size: 1.25rem;
`,
  Button: styled(Button)`
    margin-bottom: 0.75rem;
  `,
};

const OpenLinkExpired = ({ onClick }) => (
  <S.Content>
    <S.ErrorOutline />
    <S.Paragraph marginBottom="1.5rem">
      유효하지 않은 링크입니다.
      <br />
      클래스팅 앱에서 확인해 주세요.
    </S.Paragraph>
    <S.Crumbs>
      <S.Crumb>
        클래스팅 앱
      </S.Crumb>
      <S.ChevronRight />
      <S.Crumb>
        MY
      </S.Crumb>
      <S.ChevronRight />
      <S.Crumb>
        가정통신문
      </S.Crumb>
    </S.Crumbs>
    <S.Button
      type="button"
      variant="outlined"
      color="secondary"
      onClick={onClick}
    >
      앱에서 열기
    </S.Button>
  </S.Content>
);

OpenLinkExpired.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default OpenLinkExpired;
